import {
  join,
  trim,
  filter,
  concat,
  contains,
  split,
  last,
  pathOr,
  map,
  not,
  remove,
  length,
  slice,
  divide,
  isEmpty,
  isNil,
  assoc,
  reduce,
} from 'ramda';
export const LABEL_PREFIX = 'lendsmart_sh';
export const BACK_SLASH = '/';
export const UNDERSCORE = '_';
export const FIRST_NAME = 'first_name';
export const LAST_NAME = 'last_name';
export const MIDDLE_NAME = 'middle_name';
export const SUFFIX_NAME = 'suffix_name';
export const NAME_FIELDS = [
  FIRST_NAME,
  MIDDLE_NAME,
  LAST_NAME,
  SUFFIX_NAME
]

export const buildLabel = (key: string) => {
  return concat(LABEL_PREFIX, concat(BACK_SLASH, key));
};

export const buildLabelWithConnector = (key: string) => {
  return concat(LABEL_PREFIX, concat(UNDERSCORE, key));
}

export const trimLabel = (key: any) => {
  return contains(LABEL_PREFIX, key)
    ? last(split(BACK_SLASH, key))
    : key;
};


/**
fullName joins names into full name string
@param names multi-argument { list } names we need to merge
first_name ="John"
middle_name = "H"
last_name = "Smith"
suffix = "JR"
returns join of given string which is not empty
example
fullName(first_name, middle_name, last_name, suffix) => "John H Smith JR"
fullName(first_name, last_name, suffix) => "John Smith JR"
fullName(first_name, "", suffix) => "John JR"
*/
export const fullName = (...names: any) => {
  return join(' ', filter(isNotEmpty)(map(trim)(names || [])))
}

export const firstName = (obj: any) => pathOr('', [FIRST_NAME], obj)

export const lastName = (obj: any) => pathOr('', [LAST_NAME], obj)

export const middleName = (obj: any) => pathOr('', [MIDDLE_NAME], obj)

export const suffixName = (obj: any) => pathOr('', [SUFFIX_NAME], obj)

export const getFullName = (obj: any) => {
  return fullName(
    firstName(obj),
    middleName(obj),
    lastName(obj),
    suffixName(obj)
  );
}

export const isNamesEmpty = (obj: any) => {
  return isEmpty(getFullName(obj))
}

export const getNameFields = (values: any) => {
  return reduce((data, field) => assoc(field, pathOr('', [field], values), data),
    {},
    NAME_FIELDS
  )
}

// if we import isNotEmpty from hasValue getting circular dependancy
const isNotEmpty = (d: any) => not(isEmpty(d) || isNil(d))

/**
splitName is used to split the full name into two names that firstname, last name
returns object which contains firstname and lastname
example:
 splitName("John Smith") => {"first_name": "John", "last_name": "Smith"},
 splitName("John H Smith") => {"first_name": "John H", "last_name": "Smith"},
 splitName("John H Smith JR") => {"first_name": "John H", "last_name": "Smith JR"}
*/
export const splitName = (name: string) => {
  const names = split(' ', name);
  const halfLen = Math.ceil(divide(length(names), 2));
  const first_name = join(' ', slice(0, halfLen, names));
  const last = remove(0, halfLen, names) || [];
  const last_name = join(' ', last);
  return { first_name, last_name };
};
